import React, { useCallback, memo } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'

import TextInput from 'components/CommonUI/TextInput/TextInput'

const SearchInput = ({ handleChange, classNameContainer, ...rest }) => {
  const _handleChange = useCallback(
    (e) => {
      const _value = e.target.value
      if (typeof handleChange === 'function') {
        handleChange(_value)
      }
    },
    [handleChange]
  )

  const _handleClear = useCallback(() => {
    if (typeof handleChange === 'function') {
      handleChange('')
    }
  }, [handleChange])

  return (
    <TextInput
      classNameContainer={`search_input_container ${classNameContainer}`}
      startAdornment={
        <InputAdornment position="end">
          <SearchIcon />
        </InputAdornment>
      }
      endAdornment={
        rest?.value ? (
          <InputAdornment position="end" className="clear_button_container">
            <IconButton className="clear_button" onClick={_handleClear}>
              <ClearIcon className="clear_button_icon" />
            </IconButton>
          </InputAdornment>
        ) : null
      }
      onChange={_handleChange}
      {...rest}
    />
  )
}

export default memo(SearchInput)
